/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @export
 * @class KeysPipe
 * @implements {PipeTransform}
 */
@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {

  /**
   * This method is used to creat key value pairs
   * @param {any} value
   * @param {string[]} args
   * @returns {*}
   * @memberOf KeysPipe
   */
  transform(value, args: string[]): any {
    const keys = [];
    for (const key in value) {
      if (key) {
        keys.push({ key: key, value: value[key] });
      }

    }
    return keys;
  }

}

// use case

// statusList {
//   'key1':[{ 'one': 'one' }, { 'two': 'two' }],
//     'key2':[{ 'one': 'one' }, { 'two': 'two' }]

// }

// then it will give in
// in html use
// *ngFor="let status of statusList | keys"
//  status.key give 'key1'
// status.value give '[{ 'one': 'one' }, { 'two': 'two' }]' same for next
